export var noop = function () { return undefined; };
//# sourceMappingURL=noop.js.map